import { render, staticRenderFns } from "./ExtraServices.vue?vue&type=template&id=6f144477&scoped=true"
import script from "./ExtraServices.vue?vue&type=script&lang=js"
export * from "./ExtraServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f144477",
  null
  
)

export default component.exports